import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { deleteRegistryOfSuspensionReasonsFailed, deleteRegistryOfSuspensionReasonsSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { NO_CONTENT } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* deleteRegistryOfSuspensionReasonsById(action) {
  try {
    const url = `${BACKEND_URL}/resources/rejection-reasons/${action.payload}`;
    const dataResponse = yield makeRequest(url, {}, action, 'DELETE', true);
    if (dataResponse.status === NO_CONTENT) {
      yield put(deleteRegistryOfSuspensionReasonsSuccessful());
      yield call(resolveActionPromise(action));
    } else {
      yield put(deleteRegistryOfSuspensionReasonsFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(deleteRegistryOfSuspensionReasonsFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
